/**
 * Transforms a garage name or city into a URL slug:
 * lowercase, spaces to hyphens, special characters removed, accents normalised.
 */
export function toSlug(value) {
  if (!value) return '';

  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

/**
 * Generates a unique garage slug from the business name and city, avoiding collisions
 * with existing slugs in the database.
 */
export function generateGarageSlug(businessName, city, existingSlugs = []) {
  const slugSet = new Set(existingSlugs.filter(Boolean));
  const baseSlug = toSlug(businessName);

  if (!baseSlug) {
    return '';
  }

  if (!slugSet.has(baseSlug)) {
    return baseSlug;
  }

  const citySlug = toSlug(city);
  const slugWithCity = citySlug ? `${baseSlug}-${citySlug}` : baseSlug;

  if (!slugSet.has(slugWithCity)) {
    return slugWithCity;
  }

  let suffix = 2;
  while (slugSet.has(`${slugWithCity}-${suffix}`)) {
    suffix += 1;
  }

  return `${slugWithCity}-${suffix}`;
}
